import { render, staticRenderFns } from "./RationItemInfoDialog.vue?vue&type=template&id=8deb9e42&lang=pug&"
import script from "./RationItemInfoDialog.vue?vue&type=script&lang=js&"
export * from "./RationItemInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports